import { render, staticRenderFns } from "./message-send-record-query.vue?vue&type=template&id=505f4040"
import script from "./message-send-record-query.vue?vue&type=script&lang=ts"
export * from "./message-send-record-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports